export const education = {
  name: "education" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 3c0-1.05.85-1.9 1.9-1.9h14c1.05 0 1.9.85 1.9 1.9v13a1.9 1.9 0 0 1-1.9 1.9H6.5a1.6 1.6 0 0 0 0 3.2H20a.9.9 0 0 1 0 1.8H6.5a3.4 3.4 0 0 1-3.4-3.4V3Zm1.8 13.1V3a.1.1 0 0 1 .1-.1h2.1v13.2H4.9Zm4 0H19a.1.1 0 0 0 .1-.1V3a.1.1 0 0 0-.1-.1H8.9v13.2Z" clip-rule="evenodd"/></svg>`,
  keywords: ["education"],
  category: "other" as const,
};
